/* eslint-disable react/prop-types */
import type { SkeletonCell } from '../types'
import clsx from 'clsx'
import { createRenderer } from './renderer'
import { Skeleton } from '../../../shadcn'

export const Skeletons = createRenderer<SkeletonCell>({
  View: ({ className, cell }) => {
    return (
      <Skeleton className={clsx(className, 'focus-visible:outline-none h-2', { 'computed-cell': cell.computed })} />
    )
  },
  Editor: ({ className, cell }) => {
    return (
      <div className={clsx(className, { 'computed-cell': cell.computed })}>
        <Skeleton className="h-2" />
      </div>
    )
  },
})
